import React from "react";
import * as styles from "./price.module.css";
import { Box, Grid, Typography } from "@mui/material";
import CTAButton from "../../cta-button/ctaButton";

const DesktopView = ({
  node,
  quantityIncreaseHandler,
  quantityDecreaseeHandler,
  productQuantity,
}) => {
  const {
    productName,
    productImage,
    productDescriptionFirstTitle,
    productDescriptionSecondTitle,
    productPrice,
    productSaveText,
    productQuantitySelector,
    productOffText,
    orderButton,
  } = node;

  let productImageUrl = "";
  if (productImage && productImage.asset) {
    productImageUrl = productImage.asset.url;
  }

  return (
    <Box className={styles.priceBox} p={{ xs: 1, sm: 1, md: 2 }}>
      <Box mb={2}>
        <Grid container>
          <Grid item xs={12}>
            <p className={styles.priceProductName}>{productName}</p>
          </Grid>
        </Grid>
      </Box>
      {productImageUrl ? (
        <Box mb={2}>
          <Grid container justifyContent={"center"}>
            <Grid item xs={6}>
              <img src={productImageUrl} width={"100%"} />
            </Grid>
          </Grid>
        </Box>
      ) : null}
      <Box mb={2}>
        <Grid container>
          <Grid item xs={12}>
            <strong className={styles.normalText}>
              {productDescriptionFirstTitle}
            </strong>
            <p className={styles.normalText}>{productDescriptionSecondTitle}</p>
            <h2 className={styles.priceText}>{productPrice}</h2>
            <Typography
              className={styles.normalText}
              dangerouslySetInnerHTML={{ __html: productSaveText }}
            />
          </Grid>
        </Grid>
      </Box>
      {productQuantitySelector ? (
        <Box mb={2}>
          <Grid container spaing={1}>
            <Grid item xs={6}>
              <strong>
                <span className={styles.quantityText}>Quantity:</span>
              </strong>
            </Grid>
            <Grid item xs={2}>
              <button
                className={styles.quantityButton}
                onClick={quantityDecreaseeHandler}
              >
                -
              </button>
            </Grid>
            <Grid item xs={1}>
              <b className={styles.normalText}>{productQuantity}</b>
            </Grid>
            <Grid item x={2}>
              <button
                className={styles.quantityButton}
                onClick={quantityIncreaseHandler}
              >
                +
              </button>
            </Grid>
          </Grid>
        </Box>
      ) : null}
      <Box mb={2}>
        <Grid container>
          <Grid item xs={12}>
            <p className={styles.priceOffText}>{productOffText}</p>
          </Grid>
        </Grid>
      </Box>
      <Box mb={2}>
        <Grid container>
          <Grid item xs={12}>
            <CTAButton node={orderButton} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default DesktopView;
